/**
 * Auth Types
 *
 * TypeScript interfaces for authentication data
 */

/**
 * Customer token from API - matches mobile's GraphQL CustomerToken
 */
export interface CustomerToken {
    access_token?: string;
    refresh_token?: string;
    token_type?: string;
    expires_in?: number;
}

/**
 * Customer profile data
 */
export interface CustomerProfile {
    id?: string;
    email?: string;
    firstname?: string;
    lastname?: string;
    phone_number?: string;
    default_billing?: string;
    default_shipping?: string;
}

export * from './auth.types';
export * from './front.graphql';
